<form
  class="cc"
  #ccRoot
  [formGroup]="form"
  [class.cc--compact]="compact"
  [@ccCard]="viewState()"
  (ngSubmit)="onSubmit()"
>
  <!-- decorative layers -->
  <span class="cc__edge" aria-hidden="true"></span>
  <span class="cc__shine" aria-hidden="true"></span>
  <span class="cc__blob cc__blob--1" aria-hidden="true"></span>
  <span class="cc__blob cc__blob--2" aria-hidden="true"></span>
  <span class="cc__dots" aria-hidden="true"></span>

  <!-- ---------------------------------------------------- left: the pitch -->
  <div class="cc__aside" [@ccAside]="viewState()">
    <span class="cc__badge">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 2l1.9 5.6L19.5 9.5 13.9 11.4 12 17l-1.9-5.6L4.5 9.5l5.6-1.9L12 2z"
          fill="currentColor"
        />
      </svg>
      Free consultation
    </span>

    <h3 class="cc__title">Get in <span class="cc__title-grad">touch</span></h3>

    <p class="cc__sub">
      Tell us what you need — a specialist replies within one business day.
    </p>

    <ul class="cc__trust">
      <li
        class="cc-trust"
        *ngFor="let t of trust; trackBy: trackById"
        [attr.data-tone]="t.tone"
      >
        <span class="cc-trust__ico" aria-hidden="true">
          <svg
            *ngIf="t.icon === 'bolt'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12z" />
          </svg>
          <svg
            *ngIf="t.icon === 'shield'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 3 4.5 6v6c0 4.5 3.2 8.3 7.5 9.5 4.3-1.2 7.5-5 7.5-9.5V6z" />
            <path d="m9 12 2 2 4-4" />
          </svg>
          <svg
            *ngIf="t.icon === 'users'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </span>
        <span class="cc-trust__tx">
          <strong>{{ t.title }}</strong>
          <small>{{ t.desc }}</small>
        </span>
      </li>
    </ul>
  </div>

  <!-- --------------------------------------------------- right: the form -->
  <div class="cc__main" [@ccFields]="viewState()">
    <div class="cc__row">
      <!-- first name -->
      <label class="cc-field" [class.is-bad]="bad(firstname)" [class.is-filled]="filled(firstname)">
        <span class="cc-field__label">First Name<em>*</em></span>
        <span class="cc-field__box">
          <span class="cc-field__ico" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </span>
          <input
            class="cc-field__input"
            type="text"
            placeholder="Enter your first name"
            aria-label="First name"
            formControlName="firstname"
            required
            (keypress)="noSpace($event)"
          />
        </span>
        <span class="cc-field__err" *ngIf="bad(firstname)">
          <ng-container *ngIf="firstname?.errors?.['required']">Required</ng-container>
          <ng-container *ngIf="firstname?.errors?.['pattern'] && !firstname?.errors?.['required']">
            Invalid Name input
          </ng-container>
        </span>
      </label>

      <!-- last name -->
      <label class="cc-field" [class.is-bad]="bad(lastname)" [class.is-filled]="filled(lastname)">
        <span class="cc-field__label">Last Name (Optional)</span>
        <span class="cc-field__box">
          <span class="cc-field__ico" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </span>
          <input
            class="cc-field__input"
            type="text"
            placeholder="Enter your last name"
            aria-label="Last name"
            formControlName="lastname"
          />
        </span>
        <span class="cc-field__err" *ngIf="bad(lastname)">
          <ng-container *ngIf="lastname?.errors?.['required']">Required</ng-container>
          <ng-container *ngIf="lastname?.errors?.['pattern'] && !lastname?.errors?.['required']">
            Invalid Name input
          </ng-container>
        </span>
      </label>

      <!-- mobile -->
      <label class="cc-field" [class.is-bad]="bad(contact)" [class.is-filled]="filled(contact)">
        <span class="cc-field__label">Mobile Number<em>*</em></span>
        <span class="cc-field__box">
          <span class="cc-field__ico" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
            </svg>
          </span>
          <input
            class="cc-field__input"
            type="text"
            placeholder="Enter mobile number"
            aria-label="Mobile number"
            formControlName="Number"
            maxlength="10"
            required
            (keypress)="numberOnly($event)"
          />
        </span>
        <span class="cc-field__err" *ngIf="bad(contact)">
          <ng-container *ngIf="contact?.errors?.['required']">Required</ng-container>
          <ng-container *ngIf="contact?.errors?.['pattern'] && !contact?.errors?.['required']">
            Invalid input
          </ng-container>
          <ng-container
            *ngIf="(contact?.errors?.['minlength'] || contact?.errors?.['maxlength']) && !contact?.errors?.['pattern']"
          >
            Phone Number Must be of 10 Digit
          </ng-container>
        </span>
      </label>
    </div>

    <!-- email -->
    <label class="cc-field cc-field--full" [class.is-bad]="bad(email)" [class.is-filled]="filled(email)">
      <span class="cc-field__label">Email (Optional)</span>
      <span class="cc-field__box">
        <span class="cc-field__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
            <path d="m3 6.5 9 6.5 9-6.5" />
          </svg>
        </span>
        <input
          class="cc-field__input"
          type="email"
          placeholder="Enter your email address"
          aria-label="Email address"
          formControlName="email"
        />
      </span>
      <span class="cc-field__err" *ngIf="bad(email)">
        <ng-container *ngIf="email?.errors?.['required']">Required</ng-container>
        <ng-container *ngIf="email?.errors?.['pattern'] && !email?.errors?.['required']">
          Email is invalid
        </ng-container>
      </span>
    </label>

    <!-- message -->
    <label class="cc-field cc-field--full cc-field--area" [class.is-bad]="bad(msg)" [class.is-filled]="filled(msg)">
      <span class="cc-field__label">Message<em>*</em></span>
      <span class="cc-field__box">
        <span class="cc-field__ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
          </svg>
        </span>
        <textarea
          class="cc-field__input cc-field__area"
          rows="4"
          placeholder="Write your message here..."
          aria-label="Message"
          formControlName="msg"
          (keypress)="noSpace($event)"
        ></textarea>
      </span>
      <span class="cc-field__err" *ngIf="bad(msg)">
        <ng-container *ngIf="msg?.errors?.['required']">Required</ng-container>
        <ng-container *ngIf="msg?.errors?.['minlength'] && !msg?.errors?.['pattern']">
          Minimum 10 Words are Required
        </ng-container>
      </span>
    </label>

    <div class="cc__actions">
      <button
        type="submit"
        class="cc__send"
        [class.is-sending]="sending"
        [disabled]="form.invalid || sending"
      >
        <span class="cc__send-sheen" aria-hidden="true"></span>
        <span class="cc__send-spinner" aria-hidden="true"></span>
        <span class="cc__send-label">Submit</span>
        <span class="cc__send-arrow" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h13M13 6l6 6-6 6" />
          </svg>
        </span>
      </button>
    </div>
  </div>

  <p class="cc__secure">
    <span class="cc__secure-ico" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <rect x="4.5" y="10.5" width="15" height="10" rx="2.2" />
        <path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7" />
      </svg>
    </span>
    Your details stay private. No spam, ever.
  </p>
</form>
